import { render } from "./z-form-modal.vue?vue&type=template&id=27c98d39&scoped=true"
import script from "./z-form-modal.vue?vue&type=script&lang=js"
export * from "./z-form-modal.vue?vue&type=script&lang=js"

import "./z-form-modal.vue?vue&type=style&index=0&id=27c98d39&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c98d39"]])

export default __exports__